import styled from 'styled-components';

export const Wrapper = styled.div`

`;

export const ContentWrapper = styled.div`
	margin-top: 2rem;
`;
